import { BaseLayoutFactory } from "../global/base-layout-factory";
import { QuestionAwnserProvider } from "./context/question-awnser-context";
import { QuestionAwnserComponent } from "./question-awnser-component";

export function QuestionAwnserFactory() {
    return (
        <BaseLayoutFactory>
            <QuestionAwnserProvider>
                <QuestionAwnserComponent />
            </QuestionAwnserProvider>
        </BaseLayoutFactory>
    );
}